import { AppEnvironment } from "@/client/core/Core.api";
import { getAppEnvironment, isSidepanelHost } from "@/client/utils/getAppEnvironment";
import {
    deriveDisplayMode,
    kDisplayModeAttribute,
    type DisplayMode,
} from "@/client/utils/displayMode";

export const getDisplayMode = (): DisplayMode =>
    deriveDisplayMode(getAppEnvironment() === AppEnvironment.Plugin || isSidepanelHost());

/**
 * Stamps `<html data-display-mode="web|compact">` so styles can adapt via
 * `kCompactSelector`. Idempotent; call once per document boot (createCore for
 * apps, index.ts for the home page).
 */
export const applyDisplayMode = (): DisplayMode => {
    const mode = getDisplayMode();
    document.documentElement.setAttribute(kDisplayModeAttribute, mode);
    return mode;
};
